import isNumber from 'lodash.isnumber';
const getCenterCoordinates = (mapShapes, otherProps) => {
  const centerCoordinates = [];
  const {
    centerLatitude,
    centerLongitude
  } = otherProps;
  const useDefaultCenter = centerLatitude !== 0 && centerLongitude !== 0 && isNumber(centerLatitude) && isNumber(centerLongitude);
  if (useDefaultCenter) return [{
    latitude: centerLatitude,
    longitude: centerLongitude
  }];
  const useAsCenterShapes = mapShapes.filter(({
    useAsCenter
  }) => useAsCenter);
  const shapesForCenter = useAsCenterShapes.length ? useAsCenterShapes : mapShapes;
  shapesForCenter.forEach(({
    latitude,
    longitude
  }) => {
    if (isNumber(latitude) && isNumber(longitude)) centerCoordinates.push({
      latitude,
      longitude
    });
  });
  return centerCoordinates;
};
export default getCenterCoordinates;
//# sourceMappingURL=get-center-coordinates.js.map